import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[additionalLegends-host]',
  	standalone: false
})

export class AdditionalLegendsDirective {
	constructor(public viewContainerRef: ViewContainerRef ) {}
}
